var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,22H7.8C6,22,5,22,4.2,21.6c-0.8-0.4-1.4-1-1.7-1.7C2,19,2,18,2,16.2V7.8C2,6,2,5,2.4,4.2 c0.4-0.8,1-1.4,1.7-1.7C5,2,6,2,7.8,2H9c0.6,0,1,0.4,1,1S9.6,4,9,4H7.8C6.3,4,5.5,4,5.1,4.2C4.7,4.4,4.4,4.7,4.2,5.1 C4,5.5,4,6.3,4,7.8v8.4c0,1.5,0,2.3,0.2,2.7c0.2,0.4,0.5,0.7,0.9,0.9C5.5,20,6.3,20,7.8,20H9c0.6,0,1,0.4,1,1S9.6,22,9,22z M16,18 c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l3.3-3.3H9c-0.6,0-1-0.4-1-1s0.4-1,1-1h9.6l-3.3-3.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0 l5,5c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4l0,0c0,0,0,0,0,0l0,0c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.2,0.3l-5,5 C16.5,17.9,16.3,18,16,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7fbbb8e4bec8cf19456996e9a0279334.svg";
export { ForwardRef as ReactComponent };